import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatDialogModule } from '@angular/material/dialog';
import { MatIcon } from '@angular/material/icon';
import { ModalService } from '../../services/modal.service';
import { Router } from '@angular/router';
import { CondominioService } from '../../services/condominio.service';


@Component({
   selector: 'app-empreendimentos',
   imports: [CommonModule, MatDialogModule, MatIcon],
   standalone: true,
   templateUrl: './empreendimentos.component.html',
   styleUrls: ['./empreendimentos.component.scss']
})
export class EmpreendimentosComponent {

   empreendimentosCodes: number[] = [392, 1936, 247, 2126];
   empreendimentos = [
      {
         nome: 'Livty',
         endereco: 'Rua Tuiuti, Santa Maria, RS',
         foto: 'https://cdn.imoview.com.br/cancian/Condominios/392/livity-pronto-.jpg?1748289413',

         code: 392
      },
      {
         nome: 'Primado de São João',
         endereco: 'Avenida Principal, São João do Polêsine',
         foto: 'https://cdn.imoview.com.br/cancian/Condominios/2279/08-3-photo-72.jpg?1748475795',
         code: 2279

      },
      {
         nome: 'Montebello',
         endereco: 'Estrada Eduardo Duarte, Santa Maria, RS',
         foto: 'https://cdn.imoview.com.br/cancian/Condominios/2144/whatsapp-image-2023-06-09-at-174214-3.jpeg?1686343405',
         code: 2144

      },
      {
         nome: 'Vithoria do Sol',
         endereco: 'Rua Orlando Fracao, Santa Maria, RS',
         foto: 'https://cdn.imoview.com.br/cancian/Condominios/2206/prancheta-93x.png?1748475448',
         code: 2206

      }
   ];

   constructor(
      private modalService: ModalService,
      private router: Router,
      private condominioService: CondominioService) { }
   abreCondominio(idCondominio: any): void {
      // this.router.navigate(['/condominio', idCondominio]);
      const url = this.router.serializeUrl(this.router.createUrlTree(['/condominio', idCondominio]));
      window.open(url, '_blank'); // Abre em uma nova aba
   }
}
